export default __webpack_public_path__ + "static/media/balance_comment.e8091113.png";